module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch6"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("POMEGRANATE-MOLASSES CHICKEN DRUMMETTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The sweet-tart flavor of pomegranate juice and the caramel flavor of molasses make a complementary marinade for these grilled drummettes. They make a good starter for a barbecue when the grill is fired up. Drummettes are the bony part of the wing and can be purchased in packages at most meat markets.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("2 to 2 "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" pounds chicken drummettes (about 20)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup unsulphured molasses")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup pomegranate juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Place the drummettes in a 9-by-13-inch glass baking dish. In a small bowl, mix together the molasses and juice. Pour over the drummettes and marinate several hours in the refrigerator. Bring to room temperature before grilling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Prepare a grill for cooking over medium indirect heat. Remove the drummettes from the marinade and boil the marinade in a small pan for 1 minute. Place the drummettes on a lightly sprayed or oiled grate and grill until lightly browned and cooked through, about 25 minutes, turning several times and brushing with the boiled marinade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes 20 pieces")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f997919","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/014-chapter6.vue
// module id = 96
// module chunks = 0